/* ==========================================================================
  main.js
========================================================================== */

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
  component_dropdown_menu({
    desktop_min_width: 1025,
    menu: dropdown_menus[i]
  });
}

/**
 * Init mobile menu
 */
component_mobile_menu({
  menu:     document.querySelector('.js-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-menu-toggle')
});

/**
 * Init scroll observer
 */
 component_scroll_observer({
  class:  document.querySelector('.hero-links-block')
});

/**
 * Init scroll observer timeline
 */
component_scroll_observer_timeline();

/**
 * Init link-box block js
 */
 component_link_box({
  links:  document.querySelectorAll('.link-box-link')
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init smooth scroll
 */
 component_smooth_scroll();

 /**
 * Init list categories
 */
component_list_categories();

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){
    objectFitPolyfill();
    e.target.addEventListener('load', function() {
      objectFitPolyfill();
    });
  });
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  try {
    new Tobi({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

/** Breadcrumb toggle
 * When toggle is clicked, add a class to the breadcrumb wrapper
 */

var breadcrumb = document.querySelector('.breadcrumb-container ol');
var breadcrumb_toggle = document.querySelector('.js-breadcrumb-toggle');

if (breadcrumb_toggle) {
  breadcrumb_toggle.addEventListener('click', function() {
    var breadcrumb = document.querySelector('.breadcrumb-container ol');
    breadcrumb.classList.toggle('is-open');
  });
}

const checkBreadcrumbOverflow = () => {
  const breadcrumb = document.querySelector('.breadcrumbs');
  const breadcrumb_toggle = document.querySelector('.js-breadcrumb-toggle');
  const lastBreadcrumbItem = document.querySelector('.breadcrumb-container ol li:last-child');

  if (breadcrumb && lastBreadcrumbItem && breadcrumb_toggle) {
    const lastItemBox = lastBreadcrumbItem.getBoundingClientRect();
    const breadcrumbBox = breadcrumb.getBoundingClientRect();

    console.log('lastItemBox:', lastItemBox.right);
    console.log('breadcrumbBox:', breadcrumbBox.right);

    // Check if the last li's right edge is beyond the ol's right edge
    if (lastItemBox.right + 80 > breadcrumbBox.right) {
      breadcrumb_toggle.style.display = 'block';
      console.log('show');
    } else {
      breadcrumb_toggle.style.display = 'none';
      console.log('hide');
    }
  }
};

// Execute checkBreadcrumbOverflow to check if breadcrumb is overflowing.
checkBreadcrumbOverflow();

// Also check when window is resized
window.onresize = checkBreadcrumbOverflow;